module.exports = __webpack_public_path__ + "img/rd-histopathology-score.82c249dc.png";